import React, { Fragment, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearErrors, singleProductAction, updateProductAction } from "../../../redux/actions/productActions";
import { toast } from "react-toastify";
import Loader from "../../loader/loader";
import { UPDATE_PRODUCT_RESET } from "../../../redux/constants/productConstants";
import useNavHighlight from "../../../hooks/useNavHighlight";
import usePageMeta from "../../../hooks/usePageMeta";
import ProductForm from "../ProductForm";

const UpdateProduct = () => {
    const dispatch = useDispatch();

    const { loading: singleProductLoading, product, error: singleProductError } = useSelector(state => state.products);
    const { loading, error, message } = useSelector(state => state.productMessage);

    const [scan_code, setScan_code] = useState("");
    const [description, setDescription] = useState("");
    const [unit_case, setUnit_case] = useState("");
    const [department, setDepartment] = useState("");
    const [purchase_qty, setPurchase_qty] = useState(null);
    const [sold_qty, setSold_qty] = useState(null);
    const [adjust_qty, setAdjust_qty] = useState(null);
    const [current_qty, setCurrent_qty] = useState(null);
    const [each_cost, seteach_cost] = useState("");
    const [each_retail, seteach_retail] = useState("");

    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");

    useNavHighlight("/product-catalog");
    usePageMeta("updateProduct");

    useEffect(() => {
        setCurrent_qty((Number(purchase_qty) + Number(sold_qty) + Number(adjust_qty)) || null);
    }, [purchase_qty, sold_qty, adjust_qty]);

    useEffect(() => {
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }
        if (message) {
            toast.success(message);
            dispatch({ type: UPDATE_PRODUCT_RESET });
        }
    }, [error, message, dispatch]);

    useEffect(() => {
        if (id) {
            dispatch(singleProductAction(id));
        }
    }, [dispatch, id]);

    useEffect(() => {
        if (product) {
            setScan_code(product.scan_code);
            setDescription(product.description);
            setUnit_case(product.unit_case);
            setDepartment(product.department);
            setPurchase_qty(product.purchase_qty);
            setSold_qty(product.sold_qty);
            setAdjust_qty(product.adjust_qty);
            setCurrent_qty(product.current_qty);
            seteach_cost(product.each_cost);
            seteach_retail(product.each_retail);
        }
    }, [product]);

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!description) { toast.error("Please enter description"); return; }
        if (!department) { toast.error("Please enter department"); return; }
        if (!each_cost || Number(each_cost) < 0) { toast.error("Please enter cost"); return; }
        console.log(Number(each_retail));
        if (!each_retail || Number(each_retail) < 0) { toast.error("Please enter retail"); return; }
        if (Number(each_cost) > Number(each_retail)) { toast.error("Cost should be less than retail"); return; }
        if (!scan_code) { toast.error("Please enter scan code"); return; }
        if (!scan_code.trim()) return;

        let scan_codeQuery = scan_code.trim().replace(/\s/g, "");

        if (!/^\d+$/.test(scan_codeQuery)) { toast.error("Invalid barcode. Only numbers are allowed."); return; }
        if (scan_codeQuery.length > 12) { toast.error("Invalid barcode length. Maximum 12 digits allowed."); return; }

        if (scan_codeQuery.length === 8) {
            if (!/^\d{8}$/.test(scan_codeQuery)) { toast.error("Invalid UPC-E format"); }

            const S = scan_codeQuery[0];
            const a = scan_codeQuery[1];
            const b = scan_codeQuery[2];
            const c = scan_codeQuery[3];
            const d = scan_codeQuery[4];
            const e = scan_codeQuery[5];
            const N = scan_codeQuery[6];

            let expanded;
            if (["0", "1", "2"].includes(N)) { expanded = `${S}${a}${b}${N}0000${c}${d}${e}`; }
            else if (N === "3") { expanded = `${S}${a}${b}${c}00000${d}${e}`; }
            else if (N === "4") { expanded = `${S}${a}${b}${c}${d}00000${e}`; }
            else { expanded = `${S}${a}${b}${c}${d}${e}0000${N}`; }

            let sum = 0;
            for (let i = 0; i < 11; i++) {
                const digit = parseInt(expanded[i]);
                sum += (i % 2 === 0) ? digit * 3 : digit;
            }
            const checkDigit = (10 - (sum % 10)) % 10;
            scan_codeQuery = expanded + checkDigit;
        }

        const data = {
            scan_code: scan_codeQuery,
            description, unit_case, department,
            purchase_qty, sold_qty, adjust_qty, current_qty,
            each_cost, each_retail
        };

        dispatch(updateProductAction(id, data));
    };

    return (
        <Fragment>
            <section className="pl-[1.5vmax] pr-[2.5vmax] ]">
                {(loading || singleProductLoading) && <Loader />}
                <div className="flex justify-between items-center bg-white p-[1.2vmax] rounded-[1vmax] px-[2vmax]">
                    <h2 className="text-[1.3vmax] font-bold">Update Product</h2>
                    <div className="flex-center gap-[0.8vmax] text-[1vmax]">
                        <Link to={"/product-catalog"}>Product Catalog</Link>
                        <div className="w-[0.3vmax] h-[0.3vmax] rounded-[50%] bg-black"></div>
                        <span className="text-slate-400">Update Product</span>
                    </div>
                </div>
            </section>

            <section className="pl-[1.5vmax] pr-[2.5vmax] mt-[1vmax] mb-[4vmax]">
                <div className="p-[2vmax] bg-white shadow-1 rounded-2xl">
                    {singleProductError ? (
                        <div className="text-[2vmax] font-bold text-center py-[2vmax]">
                            No Product Found with this ID
                        </div>
                    ) : (
                        <ProductForm
                            scan_code={scan_code} setScan_code={setScan_code}
                            description={description} setDescription={setDescription}
                            unit_case={unit_case} setUnit_case={setUnit_case}
                            department={department} setDepartment={setDepartment}
                            purchase_qty={purchase_qty} setPurchase_qty={setPurchase_qty}
                            sold_qty={sold_qty} setSold_qty={setSold_qty}
                            adjust_qty={adjust_qty} setAdjust_qty={setAdjust_qty}
                            current_qty={current_qty} setCurrent_qty={setCurrent_qty}
                            each_cost={each_cost} seteach_cost={seteach_cost}
                            each_retail={each_retail} seteach_retail={seteach_retail}
                            onSubmit={handleSubmit}
                            submitLabel="Save Product"
                        />
                    )}
                </div>
            </section>
        </Fragment>
    );
};

export default UpdateProduct;
